export default __webpack_public_path__ + "static/media/human-development.5885eeab.svg";